import { groq } from '@nuxtjs/sanity';

const getLastNews = (ref) => groq`*[
  _type=="news" &&
  (dateTime(now()) >= dateTime(publicationDate)) &&
  !(_id in path("drafts.**"))
] | order(publicationDate desc)[0] { url, title, publicationDate}`;

export default getLastNews;
